<template>
  <v-layout column>
    <search-course-plan @reload='reload'></search-course-plan>
    <v-fade-transition mode="out-in" group tag="div">
      <div v-if="dataTableView" :key="'2'">
        <component :is="dataTableView" :section="section" :sectionItems="sectionItems" :subject="subject" :allowedRoles="hasAccess(allowedRoles)"></component>
      </div>
    </v-fade-transition>
  </v-layout>
</template>

<script>
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'
import moment from 'moment'

import SearchCoursePlan from './filters/searchCoursePlan.vue'
import TimesheetExporter from './filters/timesheetExporter.vue'
import DataTableLG from './dataTables/dataTableLG.vue'
import DataTableCombine from './dataTables/dataTableCombine.vue'
import CloneFormDialog from './forms/cloneFormDialog.vue'

export default {
  mixins: [ hasAccessMixin ],
  components: {
    SearchCoursePlan,
    DataTableLG,
    DataTableCombine,
    CloneFormDialog,
    TimesheetExporter
  },
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE', 'ROLE_DEVELOPER'],
      dataTableView: null,
      section: null,
      sectionItems: null,
      subject: null
      
    }
  },
  mounted () {
    this.$store.dispatch('person/fetchPersonItems')
  },
  methods: {
    reload (bundle) {
      this.dataTableView = null
      setTimeout(() => this.initData(bundle), 300)
    },
    initData (bundle) {
      // console.log('PARENT initData: ', bundle)     
      if(bundle.section) this.section = bundle.section
      if(bundle.sectionItems) this.sectionItems = bundle.sectionItems
      if(bundle.subject) this.subject = bundle.subject
      if(bundle.dataTableView) this.dataTableView = bundle.dataTableView

    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/index.vue